module.exports = __webpack_public_path__ + "roboto-italic-webfont-50efdad8c62f5f279e3f4f1f63a4f9bc.woff2";


//////////////////
// WEBPACK FOOTER
// ./app/javascript/fonts/roboto/roboto-italic-webfont.woff2
// module id = 860
// module chunks = 88